"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _QuantityPicker = require("@commerce-ui/core2/QuantityPicker");
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _useCartModifier2 = _interopRequireDefault(require("@deosite/api/hooks/REST/useCartModifier"));
var _useCategoryTree2 = require("@deosite/api/hooks/common/useCategoryTree");
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("@deosite/api/hooks/common/useAnalytics4AndCommerceTags"));
var _useMinicart2 = require("@deosite/api/hooks/common/useMinicart");
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(require("@deosite/helpers/hasStoreAdditionalFunctionalities"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _ProductRowPrice = _interopRequireDefault(require("../ProductRowPrice"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  otherDefaultImage: false,
  skuDisabled: false,
  isQuantityPickerEnabled: true,
  isOrderView: false,
  isProductUnavailable: false,
  rounded: false,
  showDiscountFromTotals: false,
  showAddToCartButton: false,
  maxLineName: 2,
  onLinkClick: function onLinkClick() {}
};
var ProductRow = function ProductRow(props) {
  var _product$collection, _extendedStyles$colle, _product$collection2, _product$collection3, _extendedStyles$produ, _extendedStyles$produ2, _extendedStyles$produ3, _extendedStyles$produ4, _extendedStyles$produ5, _extendedStyles$produ6;
  var product = props.product,
    deleteButton = props.deleteButton,
    qtyPicker = props.qtyPicker,
    quantity = props.quantity,
    addToCartButton = props.addToCartButton,
    _props$onLinkClick = props.onLinkClick,
    onLinkClick = _props$onLinkClick === void 0 ? defaultProps.onLinkClick : _props$onLinkClick,
    _props$isOrderView = props.isOrderView,
    isOrderView = _props$isOrderView === void 0 ? defaultProps.isOrderView : _props$isOrderView,
    _props$isQuantityPick = props.isQuantityPickerEnabled,
    isQuantityPickerEnabled = _props$isQuantityPick === void 0 ? defaultProps.isQuantityPickerEnabled : _props$isQuantityPick,
    productCategoryName = props.productCategoryName,
    _props$isProductUnava = props.isProductUnavailable,
    isProductUnavailable = _props$isProductUnava === void 0 ? defaultProps.isProductUnavailable : _props$isProductUnava,
    _props$otherDefaultIm = props.otherDefaultImage,
    otherDefaultImage = _props$otherDefaultIm === void 0 ? defaultProps.otherDefaultImage : _props$otherDefaultIm,
    _props$skuDisabled = props.skuDisabled,
    skuDisabled = _props$skuDisabled === void 0 ? defaultProps.skuDisabled : _props$skuDisabled,
    _props$maxLineName = props.maxLineName,
    maxLineName = _props$maxLineName === void 0 ? defaultProps.maxLineName : _props$maxLineName,
    roundness = props.roundness,
    extendedStyles = props.extendedStyles,
    imageOverlayOpacity = props.imageOverlayOpacity,
    _props$rounded = props.rounded,
    rounded = _props$rounded === void 0 ? defaultProps.rounded : _props$rounded,
    _props$showDiscountFr = props.showDiscountFromTotals,
    showDiscountFromTotals = _props$showDiscountFr === void 0 ? defaultProps.showDiscountFromTotals : _props$showDiscountFr,
    _props$showAddToCartB = props.showAddToCartButton,
    showAddToCartButton = _props$showAddToCartB === void 0 ? defaultProps.showAddToCartButton : _props$showAddToCartB;
  var translations = {
    productCode: (0, _langLibrary["default"])("product code"),
    addToCart: (0, _langLibrary["default"])("add to cart")
  };
  var price = product.price,
    image = product.image,
    name = product.name;
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product
    }),
    loading = _useCartModifier.loading,
    update = _useCartModifier.update,
    remove = _useCartModifier.remove,
    add = _useCartModifier.add;
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    isMinicartLoading = _useMinicart.isMinicartLoading;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    defaultValue: quantity,
    maxValue: global.__appConfig__.quantityPickerMaxValue,
    onChange: function () {
      var _onChange = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(newQty) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return update(newQty);
              case 3:
                _context.next = 8;
                break;
              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                quantityPicker.setAmount(quantity);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      return onChange;
    }()
  });
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var rowFlexStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "no-wrap",
    justifyContent: "space-between",
    alignItems: "center"
  };
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var opacityStyle = {
    opacity: isProductUnavailable ? 0.1 : 1.0
  };
  var priceRow = __jsx(_ProductRowPrice["default"], {
    showDiscountFromTotals: showDiscountFromTotals,
    price: price,
    isOrderView: isOrderView,
    opacityStyle: opacityStyle,
    isQuantityPickerEnabled: isQuantityPickerEnabled,
    quantityPicker: quantityPicker,
    extendedStyles: extendedStyles,
    quantity: quantity
  });
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, product !== null && product !== void 0 && product.url ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.id));
      onLinkClick();
    },
    sx: {
      minWidth: isQuantityPickerEnabled ? "96px" : "80px",
      height: isQuantityPickerEnabled ? "96px" : "80px"
    }
  }, __jsx(_Image["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      aspectRatio: 1,
      objectFit: "contain"
    }),
    roundness: roundness,
    image: otherDefaultImage ? otherDefaultImage.originalSrc ? otherDefaultImage : image : image,
    sizes: "210px",
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    cloudflareEnabled: global.__appConfig__.bigImageCloudflareEnabled,
    quality: global.__appConfig__.bigImageQuality,
    minified: props === null || props === void 0 ? void 0 : props.minified
  }))) : __jsx(_Box["default"], {
    sx: {
      minWidth: isQuantityPickerEnabled ? "96px" : "80px",
      height: isQuantityPickerEnabled ? "96px" : "80px"
    }
  }, __jsx(_Image["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      aspectRatio: 1,
      objectFit: "contain"
    }),
    roundness: rounded ? _Image["default"].ROUND_SOFT : _Image["default"].NO_ROUNDNESS,
    image: image,
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    sizes: "210px",
    minified: props === null || props === void 0 ? void 0 : props.minified
  })), __jsx(_Box["default"], {
    sx: {
      pl: "s6",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      color: "main",
      fill: "main",
      width: "calc(100%)",
      position: "relative",
      zIndex: 1
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, rowFlexStyle), {}, {
      font: "body2"
    })
  }, __jsx(_Box["default"], {
    sx: {
      maxWidth: "calc(100% - 30px)"
    }
  }, showAddToCartButton || isQuantityPickerEnabled ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category2;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2.id));
      onLinkClick();
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      overflow: "hidden",
      display: "-webkit-box",
      maxWidth: "100%"
    }, !((0, _hasStoreAdditionalFunctionalities["default"])(language) && isQuantityPickerEnabled) && {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: showAddToCartButton ? 1 : 3
    })
  }, name), __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: "xs_underline",
      textDecoration: "none",
      color: "neutral700",
      textTransform: "uppercase",
      position: "relative"
      //  position: showAddToCartButton ? "absolute" : "static",
      //  bottom: 45
    })
  }, translations.productCode, " ", product.sku))) : __jsx(_Box["default"], null, __jsx(_Box["default"], {
    title: product === null || product === void 0 ? void 0 : (_product$collection = product.collection) === null || _product$collection === void 0 ? void 0 : _product$collection.name,
    sx: {
      display: "inline-flex",
      width: "100%",
      font: (_extendedStyles$colle = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.collectionFont) !== null && _extendedStyles$colle !== void 0 ? _extendedStyles$colle : "xs_underline",
      textDecoration: "none",
      color: "neutral700"
    }
  }, (product === null || product === void 0 ? void 0 : (_product$collection2 = product.collection) === null || _product$collection2 === void 0 ? void 0 : _product$collection2.name) && __jsx(_Box["default"], {
    as: "span",
    sx: {
      width: "50%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      display: "block"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: product.collection.url ? product.collection : product
  }, __jsx(_LinkRaw["default"], {
    title: product.collection.name,
    onClick: function onClick() {
      var _product$category3;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category3 = product.category) === null || _product$category3 === void 0 ? void 0 : _product$category3.id));
      onLinkClick();
    }
  }, product.collection.name))), !skuDisabled && __jsx(_Box["default"], {
    as: "span",
    sx: {
      display: "block",
      width: "50%",
      textAlign: product !== null && product !== void 0 && (_product$collection3 = product.collection) !== null && _product$collection3 !== void 0 && _product$collection3.name ? "right" : "left",
      textTransform: "uppercase"
    }
  }, translations.productCode, " ", product.sku)), product !== null && product !== void 0 && product.url ? __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      var _product$category4;
      productClicked(product, getCategoryNameForGivenCategoryId((_product$category4 = product.category) === null || _product$category4 === void 0 ? void 0 : _product$category4.id));
      onLinkClick();
    },
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: (_extendedStyles$produ = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFont) !== null && _extendedStyles$produ !== void 0 ? _extendedStyles$produ : "s_sans",
      color: (_extendedStyles$produ2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ2 !== void 0 ? _extendedStyles$produ2 : "main",
      mt: "s3",
      WebkitLineClamp: maxLineName,
      WebkitBoxOrient: "vertical",
      display: "-webkit-box",
      overflow: "hidden"
    })
  }, name)) : __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: (_extendedStyles$produ3 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFont) !== null && _extendedStyles$produ3 !== void 0 ? _extendedStyles$produ3 : "s_sans",
      color: (_extendedStyles$produ4 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ4 !== void 0 ? _extendedStyles$produ4 : "main",
      mt: "s3"
    })
  }, name)), showAddToCartButton && /*#__PURE__*/_react["default"].cloneElement(addToCartButton, {
    sx: {
      $size: "small",
      position: "absolute",
      display: ["none", "flex"],
      zIndex: 2,
      bottom: 0
    },
    isLoading: loading,
    onClick: function onClick() {
      if (!loading) {
        add(1);
      }
    }
  }, translations.addToCart)), isQuantityPickerEnabled && deleteButton && __jsx(_Box["default"], {
    sx: {
      flexBasis: "30px"
    }
  }, /*#__PURE__*/_react["default"].cloneElement(deleteButton, {
    "data-test": "delete-product-minicart",
    disabled: loading || isMinicartLoading,
    onClick: function onClick() {
      if (!loading && !isMinicartLoading) {
        remove(productCategoryName, quantity);
      }
    }
  }))), __jsx(_Box["default"], {
    sx: isQuantityPickerEnabled ? rowFlexStyle : {
      display: "flex",
      font: "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ5 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ5 !== void 0 ? _extendedStyles$produ5 : "main"
    }
  }, __jsx(_Box["default"], {
    sx: isQuantityPickerEnabled ? rowFlexStyle : {
      display: "block-inline",
      font: "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ6 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ6 !== void 0 ? _extendedStyles$produ6 : "main"
    }
  }, isQuantityPickerEnabled && qtyPicker && /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    "data-test": "quantity-picker-minicart",
    controller: quantityPicker,
    loading: loading || isMinicartLoading
  }), isOrderView && quantity), !showAddToCartButton && priceRow), showAddToCartButton && __jsx(_Box["default"], {
    sx: {
      position: ["relative", "absolute"],
      right: 0,
      bottom: [0, "s6"]
    }
  }, priceRow, /*#__PURE__*/_react["default"].cloneElement(addToCartButton, {
    sx: {
      $size: "small",
      position: "relative",
      display: ["block", "none"],
      top: "s5",
      zIndex: 2,
      bottom: 0
    },
    isLoading: loading,
    onClick: function onClick() {
      if (!loading) {
        add(1);
      }
    }
  }, translations.addToCart))));
};
var _default = ProductRow;
exports["default"] = _default;